import React from 'react';
import TextField from '@/modules/common/components/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

const EndAdornment = () => <InputAdornment position="end">.*</InputAdornment>;

const RegExpField = (props) => <TextField {...props} InputProps={{endAdornment:<EndAdornment/>}}/>;

export default RegExpField;
